import { AfterContentChecked, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { SystemicCaseVO , StatuteVO} from 'src/app/services/gen';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { AlertService } from 'src/app/shared/ims-alerts/ims-alerts.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { SystemicService } from '../../systemic/systemic.service';
import { SharedEditSystemicCaseComponent } from '../shared-edit-systemic-case/shared-edit-systemic-case.component';

@Component({
	selector: 'app-modify-systemic-dialog',
	templateUrl: './modify-systemic-dialog.component.html',
	styleUrls: ['./modify-systemic-dialog.component.scss'],
})
export class ModifySystemicDialogComponent implements OnInit, AfterContentChecked {
	@ViewChild(SharedEditSystemicCaseComponent, { static: true }) child: SharedEditSystemicCaseComponent;
	hasEditRight: boolean = true;
	disableSaveBtn: boolean = false;
	hasOGC: boolean = false;
	enableSystemicInvestigation: any;
    showWatchList = true;
	statutesComb: StatuteVO[];

	constructor(
		public dialogRef: MatDialogRef<ModifySystemicDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public systemicData,
		private dashboardServ: DashboardService,
		private systemicServ: SystemicService,
		private alert: AlertService,
		private loader: LoadingService,
		private _cdrRef: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.statutesComb = this.systemicData?.statutesComb;
	}


	ngAfterContentChecked(): void {
		//Called after every check of the component's or directive's content.
		//Add 'implements AfterContentChecked' to the class.
		this._cdrRef.detectChanges();
	}

	public cancel() {
		this.dialogRef.close();
	}

	public reset() {
		this.child.clear();
	}

	public disableSave(): boolean {
		if (this.child) {
			return this.child.disableSave();
		}
		return true;
	}

	public confirmSave() {
		this.child.confirmSave();
	}

	public save(request) {
		const payload: SystemicCaseVO = request.payload ? request.payload : request;
		payload.chargesToRelate = (request?.data?.newCharges ?? []).map((x) => {
			return { chargeId: x.ciChargeInquiryId };
		});
		const removedCharges = (request?.data?.removed ?? []).map((x) => x.ciChargeInquiryId);
		if (this.systemicData?.systemicDetail) {
			// update existing systemic case
			this.loader.show();
			const requests: any[] = [
				this.dashboardServ.addSystemicCaseToCharges(
					this.systemicData?.systemicDetail?.systemicCase.systemicCaseId,
					payload.chargesToRelate
				),
				this.dashboardServ.updateSystemicCaseInformation(
					this.systemicData?.systemicDetail?.systemicCase.systemicCaseId,
					payload
				),
			];
			if (removedCharges.length > 0) {
				requests.push(
					this.dashboardServ.deleteSystemicCaseCharges(
						this.systemicData?.systemicDetail?.systemicCase.systemicCaseId,
						removedCharges
					)
				);
			}
			forkJoin(requests).subscribe(
				(_) => {
					this.loader.hide();
					this.dialogRef.close(true);
					this.alert.success('Systemic case updated successfully.');
					this.systemicServ.onSave.next(true);
				},
				(error) => {
					this.loader.hide();
					if (error.status === 422) {
						this.alert.error(error?.error , error);
					} else {
						this.alert.error('Failed to update Systemic case. Please contact help desk.', error);
					}
				}
			);
		} else {
			//create new systemic case
			this.loader.show();
			this.systemicServ.addSystemicCaseInformation(payload).subscribe(
				(res) => {
					this.loader.hide();
					this.alert.success('Systemic case created successfully.');
					this.systemicServ.onSave.next(true);
					this.dialogRef.close(res);
				},
				(error) => {
					this.loader.hide();
					if (error.status === 422) {
						this.alert.error(error?.error , error);
					} else {
						this.alert.error('Failed to create Systemic case. Please contact help desk.', error);
					}
				}
			);
		}
	}

	onSave(template: SharedEditSystemicCaseComponent) {
		template.save(true);
	}
}
